import { render, staticRenderFns } from "./BusinessGuideHeader.vue?vue&type=template&id=48ea097a"
import script from "./BusinessGuideHeader.vue?vue&type=script&lang=js"
export * from "./BusinessGuideHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports